module.exports = __webpack_public_path__ + "static/privacy-policy-banner-50cad62da1d704d6ee2bae93a13ab8be.jpg";